import { useRoutes } from 'react-router-dom';
import { useSelector } from 'react-redux';

// service type routes
import AuthenticationRoutes from './AuthenticationRoutes';
import NotFoundRoutes from './NotFoundRoutes';
import DirectorRoutes from './DirectorRoutes';
import ManagerRoutes from './ManagerRoutes';
import ITManagerRoutes from './ITManagerRoutes';
import ClinicalRoutes from './ClinicalRoutes';
import { Roles } from '../metadata/constant';
import DepartmentManagerRoutes from './DepartmentManager';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    const account = useSelector((state) => state.accountReducer);

    const routes = () => {
        if (!account || account.isSignedIn === false || !account.accessToken) {
            return [AuthenticationRoutes, NotFoundRoutes];
        }

        const role = Roles[account.role];
        if (!role) return [AuthenticationRoutes, NotFoundRoutes];

        switch (role) {
            case Roles.COM017_10:
                return [DirectorRoutes, AuthenticationRoutes, NotFoundRoutes];
            case Roles.COM017_20:
                return [ManagerRoutes, AuthenticationRoutes, NotFoundRoutes];
            case Roles.COM017_30:
            case Roles.COM017_60:
                return [ITManagerRoutes, AuthenticationRoutes, NotFoundRoutes];
            case Roles.COM017_40:
                return [DepartmentManagerRoutes, AuthenticationRoutes, NotFoundRoutes];
            case Roles.COM017_50:
                return [ClinicalRoutes, AuthenticationRoutes, NotFoundRoutes];
        }
        return [AuthenticationRoutes, NotFoundRoutes];
    };

    return useRoutes(routes());
}
